import reducer from './reducer'

import * as lendersShareOperations from './operations'
import * as lendersShareSelectors from './selectors'

export { lendersShareOperations, lendersShareSelectors }

export default reducer
